import React from 'react';
import { motion } from 'framer-motion';
import DrawInterface from '../components/draw/DrawInterface';
import BullseyeIcon from '../components/common/icons/BullseyeIcon';
import TheaterMasksIcon from '../components/common/icons/TheaterMasksIcon';
import EmailIcon from '../components/common/icons/EmailIcon';
import GlobeIcon from '../components/common/icons/GlobeIcon';

const DrawPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-slate-100">
      <div className="container mx-auto px-4 py-10">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="text-6xl mb-4 flex justify-center">
            <BullseyeIcon className="text-5xl text-primary-300 drop-shadow-lg animate-draw-glow" aria-hidden="true" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-200 via-primary-300 to-primary-400 mb-4">
            Žrebovanie Tomboly
          </h1>
          <p className="text-xl text-slate-400 mb-6">
            13. Celoslovenský ples nepočujúcich - 2026
          </p>
        </motion.div>

        <DrawInterface />

        {/* Footer */}
        <motion.footer
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="text-center mt-16 text-slate-500 border-t border-slate-800/60 pt-6"
        >
          <div className="text-xs space-y-1">
            <p className="flex items-center justify-center gap-2">
              <TheaterMasksIcon aria-hidden="true" />
              <span>Slovenský zväz posunkujúcich</span>
            </p>
            <p className="flex items-center justify-center gap-2">
              <EmailIcon aria-hidden="true" />
              <span>aplikacia@posunkujuci.com</span>
            </p>
            <p className="flex items-center justify-center gap-2">
              <GlobeIcon aria-hidden="true" />
              <span>posunkujuci.com</span>
            </p>
          </div>
        </motion.footer>
      </div>
    </div>
  );
};

export default DrawPage;